import styled from 'styled-components'
import { Image, Container, Segment } from 'semantic-ui-react'

export const BackgroundImage = styled(Image)`
    &&& {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto -1rem;
        @media (max-width: 767px) {
            transform: scale(2);
            transform-origin: right;
            opacity: .2;
            margin-left: 0.5em;
        }
    }
`

export const SliderContainer = styled(Container)`
    position: relative;
    min-height: 365px;
    margin-bottom: 2em;

    & .ui.grid {
        margin: 0;
    }
`
export const TextDiv = styled.div`
    margin-top: 1em;
`